import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/list-of-payments-by-product`

export default (queryParams = {}) =>
  http.get(`${api}`, { params: { ...queryParams } })
